// extracted by mini-css-extract-plugin
module.exports = {"container":"dangerButton_container__6e6fl","dangerButton":"dangerButton_dangerButton__3b0Im"};